<div class="custom-accordion-container" *ngIf="!isLoadingLabels && !isLoadingAccordion && !isLoadingParams">
	<div class="search" *ngIf="selectedAccordion.id == '-1'">
		<span>{{ labels.lbl_geral_buscar }} {{ labels.lbl_geral_listagem }}</span>
		<cpi-input-with-autocomplete
			[availableOptions]="userAccordionIAC"
			[placeholder]="labels.lbl_geral_buscar"
			[minInputLength]="0"
			[keepValue]="false"
			(onValueChange)="resetForm(); selectedAccordion = userAccordionDictionary[$event]; setSelectedOnForm()">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="userAccordion"
			[height]="'40dvh'"
			[insideSort]="true"
			[labels]="labels"
			(getSelectedItem)="resetForm(); selectedAccordion = userAccordionDictionary[$event[0]['id']]; setSelectedOnForm()">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="resetForm(); selectedAccordion.id = ''">{{ labels.lbl_kb_criar }}</div>
		</div>
	</div>

	<ng-container *ngIf="selectedAccordion.id != '-1'">
		<div class="wrap-header">
			<div class="tab selected">{{ labels.lbl_rep_custom_id_32 }}</div>
		</div>
		<div class="wrap-body">
			<ng-container *ngIf="!isLoadingAccordionForm">
				<div class="dotted-input-container mt-2">
					<span>{{ labels.lbl_geral_nome }}</span>
					<input [value]="selectedAccordion.name" (input)="selectedAccordion.name = $event.target.value" />
				</div>

				<pcp-search-filter
					[availableFiltersGeneric]="accordionForm"
					[titleLabel]="labels.lbl_geral_parametros"
					[tipLabel]="labels.lbl_poucos_parametros_aumentam_tempo_busca"
					[mandatoryFilters]="mandatoryFilters"
					(getFilterGeneric)="setSelectedAccordionParams($event)">
				</pcp-search-filter>

				<div class="button-container">
					<div class="button" *ngIf="selectedAccordion.id != '-1'" (click)="backToHome()">{{ labels.lbl_geral_voltar }}</div>
					<div class="button" (click)="resetForm(); selectedAccordion.id = ''">{{ labels.lbl_geral_limpar_campos }}</div>
					<div
						class="button"
						[ngClass]="{ disabled: isUpdatingAccordion || isDeletingAccordion }"
						(click)="
							deleteAccordion.classList.contains('confirmClick') ? deleteCustomAccordion() : confirmButton(deleteAccordion)
						"
						#deleteAccordion
						*ngIf="selectedAccordion.id !== '' && selectedAccordion.id != '-1'">
						{{ labels.lbl_geral_excluir }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isDeletingAccordion"></cpi-dot-bounce-loading-effect>
					</div>
					<div
						class="button"
						[ngClass]="{ disabled: isUpdatingAccordion }"
						(click)="createCustomAccordion()"
						*ngIf="selectedAccordion.id === ''">
						{{ labels.lbl_kb_criar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isUpdatingAccordion"></cpi-dot-bounce-loading-effect>
					</div>
					<div
						class="button"
						[ngClass]="{ disabled: isUpdatingAccordion || isDeletingAccordion }"
						(click)="updateCustomAccordion()"
						*ngIf="selectedAccordion.id !== '' && selectedAccordion.id != '-1'">
						{{ labels.lbl_geral_atualizar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isUpdatingAccordion"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</ng-container>
			<cpi-dot-bounce-loading-effect
				[color]="'var(--primary-color-1)'"
				*ngIf="isLoadingAccordion || isLoadingAccordionForm"></cpi-dot-bounce-loading-effect>
		</div>
	</ng-container>
</div>
<cpi-dot-bounce-loading-effect [color]="'var(--primary-color-1)'" *ngIf="isLoadingParams"></cpi-dot-bounce-loading-effect>
